import { State } from '../../../types/state';
import { MIQAmenity } from '../../actions/system/load-miq-amenities';

export const getMiqAmenitiesByKey = (state: State, country: string, propertyType: string): MIQAmenity[] => {
    const cacheKey = `${country}_${propertyType}`;
    if (!state.system || !state.system.miqAmenitiesCache) {
        return [];
    }
    return state.system.miqAmenitiesCache[cacheKey] || [];
};
